import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuidv4 } from 'uuid'
import addIcon from '../../../assets/icons/plus.svg'
import TextFieldWithDelete from '../FormFields/TextFieldWithDelete'
import './style.sass'

const TextInputList = ({ values, errors, displayName, placeholder, disabled, onChange }) => {

  const [inputsList, setInputsList] = useState([])
  const shouldTriggerOnChange = useRef(false)

  // Init inputsList based on values
  useEffect(() => {
    if (Array.isArray(values)) {
      const initialInputsList = values.map(val => ({
        inputId: uuidv4(), 
        id: val.id,
        value: val.value
      }))
      setInputsList(initialInputsList)
    }
  }, [])

  // Trigger on change when inputsList changes (onAddInputClicked and onDeleteInputClicked will trigger this)
  useEffect(() => {
    if (Array.isArray(inputsList) && shouldTriggerOnChange.current) {
      onChange(inputsList)
    }
    shouldTriggerOnChange.current = inputsList.length > 0 // This is used to prevent unwanted triggering of this useeffect
  }, [inputsList])

  const onAddInputClicked = () => {
    setInputsList(inputItems => {
      const updatedInputList = [...inputItems, { inputId: uuidv4(), value: "" }]
      return updatedInputList
    })
  }
  
  const onDeleteInputClicked = (inputId) => {
    setInputsList(inputItems => {
      const updatedInputList = inputItems.filter(inputItem => inputItem.inputId !== inputId)
      return updatedInputList
    })
  }

  const onInputValueChange = (val, inputId) => {
    setInputsList(inputItems => {
      const inputObjIndex = inputItems.findIndex((obj => obj.inputId === inputId))
      inputItems[inputObjIndex].value = val

      setTimeout(() => onChange(inputItems), 5) // Time out to prevent warning
      return inputItems
    })
  }

  const getMainErrorMessage = () => {
    return errors?.mainErrorMessage 
  }

  const getInputErrorMessage = (inputId) => {
    const inputErrorObject = errors?.inputErrors?.find(error => error.inputId === inputId && error.inputErrorMessage !== null)
    return inputErrorObject?.inputErrorMessage
  }

  const renderInputsList = () => {
    return inputsList?.map(inputItem => (
      <TextFieldWithDelete
        key={inputItem.inputId}
        placeholder={placeholder}
        onChange={(val) => onInputValueChange(val, inputItem.inputId)}
        onDeletedClicked={() => onDeleteInputClicked(inputItem.inputId)}
        value={inputItem.value}
        errorMessage={getInputErrorMessage(inputItem.inputId)}
        disabled={disabled}
      />
    ))
  }

  return (
    <div className="text-input-list-component-container">
      <label className="main-label-text">{displayName}</label>
      {renderInputsList()}
      {!disabled ? (
        <label className="add-another-button" onClick={() => onAddInputClicked()}>
          <img src={addIcon} alt='add' /> Add {inputsList?.length > 0 ? "another" : ""}
        </label>
      ) : null}
      <label className="main-error-text">{getMainErrorMessage()}</label>
    </div>
  )
}

TextInputList.propTypes = {
  values: PropTypes.array,
  errors: PropTypes.object,
  displayName: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool, 
  onChange: PropTypes.func
}

export default TextInputList